var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 6.72222C90.2122 6.72222 114.278 30.7878 114.278 60.5C114.278 90.2122 90.2122 114.278 60.5 114.278C30.7878 114.278 6.72222 90.2122 6.72222 60.5C6.72222 30.7878 30.7878 6.72222 60.5 6.72222ZM60.5 0C27.0233 0 0 27.0233 0 60.5C0 93.9767 27.0233 121 60.5 121C93.9767 121 121 93.9767 121 60.5C121 27.0233 93.8422 0 60.5 0Z",
    fill: "#5981e9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0926 45.5761L56.1959 82.2794C55.3892 83.0861 54.1792 83.6239 52.8348 83.6239C51.4904 83.6239 50.4148 83.0861 49.4737 82.2794L29.1726 61.575C28.3659 60.7683 27.8281 59.5583 27.8281 58.2139C27.8281 55.525 29.9792 53.3739 32.5337 53.3739C33.8781 53.3739 34.9537 53.9117 35.8948 54.7183L52.8348 72.0617L85.5048 38.7194C86.3115 37.9128 87.5215 37.375 88.8659 37.375C91.4203 37.375 93.5715 39.5261 93.5715 42.215C93.437 43.5594 92.8992 44.7694 92.0926 45.5761Z",
    fill: "#5981e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.cd43c7db121ec5d4c740f770e28c3e40.svg";
export { ForwardRef as ReactComponent };